import {
	Gender,
	IPedAppearanceValue,
	IPedFaceMorphValue,
	IPedOverlayValue,
	IPedParentsValue,
	PedFaceMorphSection,
	PedHeadPosition,
	PedOverlaySection,
} from '~/shared';
import { AbstractCharacterCreationService } from './AbstractCharacterCreationService';

export class CharacterCreationServiceStub extends AbstractCharacterCreationService {
	private readonly RULES = {
		isEnabled: true,
		isBarberShopEnabled: true,
		isCharCreationEnabled: true,
	};

	constructor() {
		super();

		this.parents.next([
			{ index: 0, name: 'Бенджамен', gender: Gender.MALE },
			{ index: 1, name: 'Даниэль', gender: Gender.MALE },
			{ index: 2, name: 'Джошуа', gender: Gender.MALE },
			{ index: 21, name: 'Ханна', gender: Gender.FEMALE },
			{ index: 22, name: 'Одри', gender: Gender.FEMALE },
			{ index: 23, name: 'Жасмин', gender: Gender.FEMALE },
		]);

		this.faceMorphs.next([
			{ index: 0, section: PedFaceMorphSection.Nose, name: 'Ширина носа' },
			{ index: 1, section: PedFaceMorphSection.Nose, name: 'Высота носа' },
			{ index: 2, section: PedFaceMorphSection.Nose, name: 'Длина носа' },
			{ index: 3, section: PedFaceMorphSection.Nose, name: 'Переносица' },
			{ index: 4, section: PedFaceMorphSection.Nose, name: 'Кончик носа' },
			{
				index: 5,
				section: PedFaceMorphSection.Nose,
				name: 'Смещение переносицы',
			},
			{ index: 6, section: PedFaceMorphSection.Brow, name: 'Высота бровей' },
			{ index: 7, section: PedFaceMorphSection.Brow, name: 'Ширина бровей' },
			{ index: 8, section: PedFaceMorphSection.Cheekbone, name: 'Высота скул' },
			{ index: 9, section: PedFaceMorphSection.Cheekbone, name: 'Ширина скул' },
			{
				index: 10,
				section: PedFaceMorphSection.Cheeks,
				name: 'Выпуклость щек',
			},
			{ index: 11, section: PedFaceMorphSection.Eyes, name: 'Открытость глаз' },
			{ index: 12, section: PedFaceMorphSection.Lips, name: 'Толщина губ' },
			{ index: 13, section: PedFaceMorphSection.Jaw, name: 'Ширина челюсти' },
			{ index: 14, section: PedFaceMorphSection.Jaw, name: 'Высота челюсти' },
			{
				index: 15,
				section: PedFaceMorphSection.Chin,
				name: 'Длина подбородка',
			},
			{
				index: 16,
				section: PedFaceMorphSection.Chin,
				name: 'Положение подбородка',
			},
			{
				index: 17,
				section: PedFaceMorphSection.Chin,
				name: 'Ширина подбородка',
			},
			{
				index: 18,
				section: PedFaceMorphSection.Chin,
				name: 'Форма подбородка',
			},
			{ index: 19, section: PedFaceMorphSection.Neck, name: 'Толщина шеи' },
		]);

		const overlaySections = [
			{
				index: 0,
				section: PedOverlaySection.Blemishes,
				name: 'Дефекты кожи лица',
				withColor: false,
				withOpacity: true,
			},
			{
				index: 1,
				section: PedOverlaySection.FacialHair,
				name: 'Волосы на лице',
				withColor: true,
				withOpacity: true,
			},
			{
				index: 2,
				section: PedOverlaySection.Eyebrows,
				name: 'Брови',
				withColor: true,
				withOpacity: true,
			},
			{
				index: 3,
				section: PedOverlaySection.Ageing,
				name: 'Старение кожи',
				withColor: false,
				withOpacity: true,
			},
			{
				index: 4,
				section: PedOverlaySection.Makeup,
				name: 'Макияж глаз',
				withColor: true,
				withOpacity: true,
			},
			{
				index: 5,
				section: PedOverlaySection.Blush,
				name: 'Раскраска лица',
				withColor: false,
				withOpacity: true,
			},
			{
				index: 6,
				section: PedOverlaySection.Complexion,
				name: 'Тип кожи',
				withColor: false,
				withOpacity: true,
			},
			{
				index: 7,
				section: PedOverlaySection.SunDamage,
				name: 'Повреждение кожи',
				withColor: false,
				withOpacity: true,
			},
			{
				index: 8,
				section: PedOverlaySection.Lipstick,
				name: 'Помада',
				withColor: false,
				withOpacity: true,
			},
			{
				index: 9,
				section: PedOverlaySection.MolesFreckles,
				name: 'Родинки и веснушки',
				withColor: false,
				withOpacity: true,
			},
			{
				index: 10,
				section: PedOverlaySection.BodyHair,
				name: 'Грудь',
				withColor: true,
				withOpacity: true,
			},
			{
				index: 11,
				section: PedOverlaySection.Hair,
				name: 'Прическа',
				withColor: true,
				withOpacity: true,
			},
			{
				index: 12,
				section: PedOverlaySection.Eyes,
				name: 'Цвет глаз/линз',
				withColor: false,
				withOpacity: false,
			},
			{
				index: 13,
				section: PedOverlaySection.BodyBlemishes,
				name: 'Дефекты кожи на теле',
				withColor: false,
				withOpacity: true,
			},
			{
				index: 14,
				section: PedOverlaySection.AddBodyBlemishes,
				name: 'Доп. дефекты кожи на теле',
				withColor: false,
				withOpacity: true,
			},
		];
		this.overlaySections.next(overlaySections);

		const overlaysFemale = [
			{
				section: PedOverlaySection.Blemishes,
				index: -1,
				name: 'Отсутствует',
				gender: Gender.FEMALE,
			},
			{
				section: PedOverlaySection.Blemishes,
				index: 0,
				name: 'Краснуха',
				gender: Gender.FEMALE,
			},
			{
				section: PedOverlaySection.Blemishes,
				index: 1,
				name: 'Корь',
				gender: Gender.FEMALE,
			},
			{
				section: PedOverlaySection.Eyebrows,
				index: 0,
				name: 'Аккуратные',
				gender: Gender.FEMALE,
			},
			{
				section: PedOverlaySection.Eyebrows,
				index: 1,
				name: 'Модные',
				gender: Gender.FEMALE,
			},
			{
				section: PedOverlaySection.Eyebrows,
				index: 2,
				name: 'Клеопатра',
				gender: Gender.FEMALE,
			},
			{
				section: PedOverlaySection.Makeup,
				index: -1,
				name: 'Отсутствует',
				gender: Gender.FEMALE,
			},
			{
				section: PedOverlaySection.Makeup,
				index: 0,
				name: 'Натуральный',
				gender: Gender.FEMALE,
			},
			{
				section: PedOverlaySection.Makeup,
				index: 1,
				name: 'Смоки',
				gender: Gender.FEMALE,
			},
			{
				section: PedOverlaySection.Makeup,
				index: 2,
				name: 'Стрелки',
				gender: Gender.FEMALE,
			},
			{
				section: PedOverlaySection.Blush,
				index: -1,
				name: 'Отсутствует',
				gender: Gender.FEMALE,
			},
			{
				section: PedOverlaySection.Blush,
				index: 0,
				name: 'Нежный',
				gender: Gender.FEMALE,
			},
			{
				section: PedOverlaySection.Blush,
				index: 1,
				name: 'Яркий',
				gender: Gender.FEMALE,
			},
			{
				section: PedOverlaySection.Lipstick,
				index: -1,
				name: 'Отсутствует',
				gender: Gender.FEMALE,
			},
			{
				section: PedOverlaySection.Lipstick,
				index: 0,
				name: 'Классический',
				gender: Gender.FEMALE,
			},
			{
				section: PedOverlaySection.Lipstick,
				index: 1,
				name: 'Матовый',
				gender: Gender.FEMALE,
			},
			{
				section: PedOverlaySection.Lipstick,
				index: 2,
				name: 'Глянцевый',
				gender: Gender.FEMALE,
			},
		];
		this.overlaysFemale.next(
			overlaysFemale.map((e) => ({ ...e, ...this.RULES })),
		);

		const overlaysMale = [
			{
				section: PedOverlaySection.Blemishes,
				index: -1,
				name: 'Отсутствует',
				gender: Gender.MALE,
			},
			{
				section: PedOverlaySection.Blemishes,
				index: 0,
				name: 'Краснуха',
				gender: Gender.MALE,
			},
			{
				section: PedOverlaySection.Blemishes,
				index: 1,
				name: 'Корь',
				gender: Gender.MALE,
			},
			{
				section: PedOverlaySection.FacialHair,
				index: -1,
				name: 'Отсутствует',
				gender: Gender.MALE,
			},
			{
				section: PedOverlaySection.FacialHair,
				index: 0,
				name: 'Легкая щетина',
				gender: Gender.MALE,
			},
			{
				section: PedOverlaySection.FacialHair,
				index: 1,
				name: 'Бальбо',
				gender: Gender.MALE,
			},
			{
				section: PedOverlaySection.Eyebrows,
				index: 0,
				name: 'Аккуратные',
				gender: Gender.MALE,
			},
			{
				section: PedOverlaySection.Eyebrows,
				index: 1,
				name: 'Модные',
				gender: Gender.MALE,
			},
			{
				section: PedOverlaySection.Eyebrows,
				index: 2,
				name: 'Клеопатра',
				gender: Gender.MALE,
			},
			{
				section: PedOverlaySection.Makeup,
				index: -1,
				name: 'Отсутствует',
				gender: Gender.MALE,
			},
			{
				section: PedOverlaySection.Makeup,
				index: 0,
				name: 'Натуральный',
				gender: Gender.MALE,
			},
			{
				section: PedOverlaySection.Makeup,
				index: 1,
				name: 'Смоки',
				gender: Gender.MALE,
			},
			{
				section: PedOverlaySection.Blush,
				index: -1,
				name: 'Отсутствует',
				gender: Gender.MALE,
			},
			{
				section: PedOverlaySection.Blush,
				index: 0,
				name: 'Нежный',
				gender: Gender.MALE,
			},
			{
				section: PedOverlaySection.Lipstick,
				index: -1,
				name: 'Отсутствует',
				gender: Gender.MALE,
			},
			{
				section: PedOverlaySection.Lipstick,
				index: 0,
				name: 'Классический',
				gender: Gender.MALE,
			},
		];
		this.overlaysMale.next(overlaysMale.map((e) => ({ ...e, ...this.RULES })));

		const hairColors = [
			{ index: 0, hex: '1c1f21' },
			{ index: 1, hex: '272a2c' },
			{ index: 2, hex: '312e2c' },
			{ index: 3, hex: '35261c' },
			{ index: 4, hex: '4b321f' },
			{ index: 5, hex: '5c3b24' },
		];
		this.hairColors.next(hairColors.map((e) => ({ ...e, ...this.RULES })));

		const makeupColors = [
			{ index: 0, hex: '992532' },
			{ index: 1, hex: 'c8395d' },
			{ index: 2, hex: 'bd516c' },
			{ index: 3, hex: 'b8637a' },
			{ index: 4, hex: 'a6526b' },
			{ index: 5, hex: 'b1434c' },
		];
		this.makeupColors.next(makeupColors.map((e) => ({ ...e, ...this.RULES })));
	}

	public async setGenderValue(gender: Gender): Promise<void> {
		console.log('characterCreation:setGender', { gender });
	}

	public async setParentsValue(parents: IPedParentsValue): Promise<void> {
		console.log('characterCreation:setParents', { parents });
	}

	public async setFaceMorphValues(morphs: IPedFaceMorphValue[]): Promise<void> {
		console.log('characterCreation:setFaceMorphs', { morphs });
	}

	public async setOverlayValues(overlays: IPedOverlayValue[]): Promise<void> {
		console.log('characterCreation:setOverlays', { overlays });
	}

	public async setAppearanceValue(
		appearance: IPedAppearanceValue,
	): Promise<void> {
		console.log('characterCreation:setAppearance', {
			appearance,
		});
	}

	public async createCharacter(
		firstName: string,
		lastName: string,
		appearance: IPedAppearanceValue,
	): Promise<void> {
		console.log('characterCreation:create', {
			firstName,
			lastName,
			appearance,
		});
	}

	public async setHeadPosition(position: PedHeadPosition): Promise<void> {
		console.log('characterCreation:setHeadPosition', { position });
	}

	public async exit(): Promise<void> {
		console.log('characterCreation:close');
	}
}
